package com.mrpowergamerbr.puppydough

import web.cssom.ClassName
import web.dom.ParentNode
import web.html.HtmlTagName

fun ParentNode.processingGame(currentFile: String, count: Int, total: Int) {
    el(HtmlTagName.div) {
        className = ClassName("status")

        el(HtmlTagName.div) {
            textContent = "Processing..."
        }

        val progress = (count / total.toDouble()) * 100.0

        el(HtmlTagName.div) {
            className = ClassName("undertale-progress-bar-label")

            textContent = "${progress.toInt()}% (${count}/${total})"
        }

        el(HtmlTagName.div) {
            className = ClassName("undertale-progress-bar-wrapper")

            el(HtmlTagName.div) {
                className = ClassName("undertale-progress-bar")

                el(HtmlTagName.div) {
                    className = ClassName("undertale-progress-bar-fill")
                    style.width = "${progress}%"
                }
            }
        }

        el(HtmlTagName.div) {
            setAttribute("style", "color: #BBBBBB;")
            textContent = currentFile
        }
    }
}